import styled from 'styled-components';
import { BodyRegularS, CaptionRegularM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';
import { ErrorMsgCont } from '../SearchDropdown.styles';

interface ISearchDropInputCont {
  theme: ITheme;
  width?: string;
  height?: string;
  error?: boolean;
  highLighted?: boolean;
  isDisabled?: boolean;
}

export const DropContentCont = styled.div`
  position: relative;
`;
export const SearchDropInputCont = styled.div<ISearchDropInputCont>`
  position: relative;
  display: flex;
  align-items: center;
  ${({ theme, width, height, error, highLighted, isDisabled }: ISearchDropInputCont) => `
       background: ${theme.colors.neutral.primary[0]};
       border: 2px solid ${
  error ? theme.colors.support.orange[100] : theme.colors.neutral.primary[20]
};
       border-radius: 8px;
       height: ${height || '48px'};
       width: ${width || '320px'};
       padding: 0 23px 0 12px;
       ${
  highLighted
    ? `
        border: 2px solid ${theme.colors.secondary[100]};
       `
    : ''
}
      cursor: ${isDisabled ? 'initial' : 'pointer'};
    `};
`;

export const InfoStaticIconCont = styled.div`
  position: absolute;
  bottom: -23px;
  left: -2px;
  svg {
    width: 13px;
    height: 13px;
  }
`;

export const InfoStaticMessage = styled(CaptionRegularM)`
  position: relative;
  top: -2px;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[60]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

export const ErrorStaticIconCont = styled.div`
  position: absolute;
  top: 11px;
  right: 38px;
`;

interface IDropDownStaticHead {
  theme: ITheme;
  isDisabled?: boolean;
}

export const DropDownStaticHead = styled(BodyRegularS)<IDropDownStaticHead>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  ${({ theme, isDisabled }: IDropDownStaticHead) => `
    color: ${isDisabled ? theme.colors.neutral.primary[60] : 'inherit'};
  `}
`;

export const StaticIconImg = styled.img`
  ${({ theme }: IThemeProvider) => `
      margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;

export const DropDownStaticPlaceholder = styled(DropDownStaticHead)`
  ${({ theme }: IThemeProvider) => `
       color: ${theme.colors.neutral.primary[60]};
    `};
`;

export const StaticErrorMsgCont = styled(ErrorMsgCont)`
  left: 0;
  bottom: -19px;
`;

export const ErrorMessage = styled(CaptionRegularM)`
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.support.orange[100]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

interface IArrowCont {
  theme: ITheme;
  active?: boolean;
  sortFeature?: boolean;
}

export const ArrowCont = styled.div<IArrowCont>`
  position: absolute;
  cursor: pointer;
  svg {
    height: 12px;
    width: 12px;
  }
  transition: all 0.05s;
  transition-timing-function: cubic-bezier(0.1, 0.7, 1, 0.1);
  ${({ active, sortFeature }: IArrowCont) => `
        right: ${sortFeature ? `${active ? '64px' : '68px'}` : `${active ? '14px' : '18px'}`};
        transform:  ${active ? 'rotate(270deg)' : 'rotate(90deg)'}
    `};
`;

interface ISortArrowsCont {
  theme: ITheme;
  highlighted?: boolean;
}
export const SortArrowsCont = styled.div<ISortArrowsCont>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 0;
  border-radius: 0 5px 5px 0;
  width: 50px;
  height: 100%;
  // border: 2px solid black;
  overflow: hidden;

  ${({ theme, highlighted }: ISortArrowsCont) => `
    border: 2px solid ${
  highlighted ? theme.colors.secondary[100] : theme.colors.neutral.primary[20]
};
  `}
`;

interface ISortArrowCont {
  theme: ITheme;
  active?: boolean;
}

export const SortArrowCont = styled.div<ISortArrowCont>`
  cursor: pointer;
  width: 24px;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme, active }: ISortArrowCont) => `
  background: ${active ? theme.colors.secondary[100] : theme.colors.neutral.primary[0]};
  border: 1px solid ${active ? theme.colors.secondary[100] : theme.colors.neutral.primary[0]};
  svg {
    width: 10px;
    filter: ${active ? 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))' : ''};

    path {
      fill: ${active ? theme.colors.neutral.primary[0] : theme.colors.neutral.primary[100]};
    }
  }
  `};
`;

export const SortUpArrowCont = styled(SortArrowCont)`
  transform: rotate(180deg);
`;

export const Label = styled.span`
  text-align: start;
  position: relative;
  left: 5px;
`;

export const ClearAction = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  text-decoration-line: underline;
  cursor: pointer;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.support.blue[100]};
  `}
`;
